/** Signature widget payload for session/OTP authorize endpoints. */
export function extractSignatureFromWidgets(widgets) {
  const signatureWidget = Object.values(widgets || {}).find(
    widget =>
      widget &&
      typeof widget === 'object' &&
      (widget.type === 'drawn' || widget.type === 'typed' || widget.type === 'uploaded'),
  );

  return signatureWidget
    ? {
        signatureValue: signatureWidget.data || '',
        signatureType: signatureWidget.type || 'drawn',
      }
    : null;
}
